import { render, staticRenderFns } from "./edit-declare-customsotherinfo.vue?vue&type=template&id=8726a910&scoped=true"
import script from "./edit-declare-customsotherinfo.vue?vue&type=script&lang=ts"
export * from "./edit-declare-customsotherinfo.vue?vue&type=script&lang=ts"
import style0 from "./edit-declare-customsotherinfo.vue?vue&type=style&index=0&id=8726a910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8726a910",
  null
  
)

export default component.exports